import {Component, Inject, OnInit} from '@angular/core';
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {FormControl, FormsModule, ReactiveFormsModule, ValidatorFn, Validators} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {MatError, MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {NgIf} from "@angular/common";
import {DialogMessageData} from "../dialog-message-box/dialog-message-box.component";
import {EscapeAwareMaxLengthDirective} from "../../../directives/escape-aware-max-length.directive";
import {EscapeAwareCharCountPipe} from "../../../pipes/escape-aware-char-count.pipe";

@Component({
  selector: 'app-dialog-mandatory-comment-box',
  imports: [
    CdkTextareaAutosize,
    FormsModule,
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatFormField,
    MatHint,
    MatInput,
    MatLabel,
    NgIf,
    MatError,
    ReactiveFormsModule,
    EscapeAwareMaxLengthDirective,
    EscapeAwareCharCountPipe
  ],
  templateUrl: './dialog-mandatory-comment-box.component.html',
  styleUrl: './dialog-mandatory-comment-box.component.scss',
  standalone: true
})
export class DialogMandatoryCommentBoxComponent implements OnInit{

  textFormControl!: FormControl;

  constructor(
    private dialogRef: MatDialogRef<DialogMandatoryCommentBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public resultText: string
    ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.initializeFormControl();
    this.textFormControl.markAsTouched();
  }

  private initializeFormControl() {
    const validators: ValidatorFn[] = [
      Validators.required,
      Validators.minLength(1)

    ];

    this.textFormControl = new FormControl('', validators);
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  onSendClick(){
    if(this.textFormControl.valid){
      this.dialogRef.close(this.textFormControl.value);
    }
  }

}
